import React, { useEffect, useMemo, useState } from 'react';
import { Button, Box, Autocomplete, TextField } from '@mui/material';
import { adminOrTeacher, admin } from "../../utils/validation";
import Loader from '../../elements/Loader';
import AddGroup from '../../elements/AddGroup';
import CourseCard from '../../elements/CourseCard';

const width = window.innerWidth;
const threeColumns = width < 1452 && width >= 1080;
const twoColumns = width < 1080 && width >= 709;
const oneColumn = width < 709;

const LessonsGroupList = props => {
    const { currentUser, history, groups, fetchGroups, isLoading, createGroup } = props;

    const role = currentUser.optional && currentUser.optional.role;

    const avaliableGroups = useMemo(() => role !== 'admin' ? currentUser?.optional?.groups : groups, [role, currentUser, groups]);

    const [search, setSearch] = useState('');

    const filteredGroups = useMemo(() => avaliableGroups.filter(el => search ? el.includes(search.toUpperCase()) : true), [avaliableGroups, search])

    useEffect(() => {
        role === 'admin' && fetchGroups();
        // eslint-disable-next-line 
    }, [])

    return isLoading ? <Loader /> : <Box display='block'>
        <h1 className="text-center">Courses</h1>
        <div className='text-center'>
            <p>
                This is the list of all your courses
            </p>
        </div>
        <Box display={twoColumns || oneColumn ? 'grid' : 'flex'} justifyContent='center' gap='1.5rem' maxWidth='1450px'>
            <Box width={`${threeColumns || oneColumn ? '15rem' : '31.5rem'}`} marginTop='2rem'>
                {avaliableGroups?.length > 6 && <Autocomplete
                    options={avaliableGroups ?? []}
                    freeSolo
                    disableClearable
                    onSelect={(e) => setSearch(e.target.value)}
                    filterOptions={(options) => options.filter(el => search && el.includes(search.toUpperCase()))}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Search"
                            fullWidth={true}
                            InputProps={{
                                ...params.InputProps,
                                type: 'search',
                            }}
                        />
                    )} />}
            </Box>
            <Box display={oneColumn ? 'grid' : 'flex'} justifyContent='start' marginTop={twoColumns || oneColumn ? 'grid' : '2rem'} gap='1.5rem'>
                {adminOrTeacher(currentUser) &&
                    <Button variant="outlined" className="secondary-button" onClick={() => history.push(`/lesson/add`)}>
                        ADD LESSON
                    </Button>}
                {admin(currentUser) &&
                    <AddGroup groups={groups} createGroup={createGroup} showImage={!oneColumn} />}
            </Box>
        </Box>
        <div className='lessons-list'>
            {
                filteredGroups?.map((el, i) => <CourseCard key={i} group={el} onClick={() => history.push(`/lessons/${el}`)} />)
            }
        </div>
    </Box>
}

export default LessonsGroupList